export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20minimal%20workspace%20with%20an%20open%20laptop%20showing%20organized%20product%20categories%2C%20surrounded%20by%20neatly%20folded%20clothing%20items%20and%20a%20notebook%2C%20warm%20sand%20and%20cream%20tones%2C%20natural%20morning%20light%2C%20clean%20productive%20aesthetic%2C%20editorial%20photography%2C%20calm%20organized%20atmosphere&width=800&height=600&seq=whatis-v3&orientation=landscape"
                alt="What is Sugargoo Spreadsheet - Product discovery system displayed on laptop with organized categories"
                title="Sugargoo Spreadsheet Product Discovery System"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>

          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
              About
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              What Is <span className="text-primary-500">Sugargoo Spreadsheet</span>?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Sugargoo Spreadsheet is an organized product discovery system that helps international shoppers find products faster, compare options, review quality information, and make smarter purchasing decisions. Instead of spending hours searching manually, users can access structured categories including sneakers, streetwear, hoodies, jackets, accessories, and trending products.
            </p>

            <div className="overflow-hidden rounded-lg border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/70">
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800">Feature</th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-500">Traditional Searching</th>
                    <th className="text-left px-4 py-3 font-semibold text-primary-600">Sugargoo Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-background-200/50">
                    <td className="px-4 py-2.5 font-medium text-foreground-800">Product Discovery</td>
                    <td className="px-4 py-2.5 text-foreground-500">Slow</td>
                    <td className="px-4 py-2.5 text-accent-600 font-medium">Fast</td>
                  </tr>
                  <tr className="border-t border-background-200/50 bg-background-50">
                    <td className="px-4 py-2.5 font-medium text-foreground-800">Organization</td>
                    <td className="px-4 py-2.5 text-foreground-500">Poor</td>
                    <td className="px-4 py-2.5 text-accent-600 font-medium">Structured</td>
                  </tr>
                  <tr className="border-t border-background-200/50">
                    <td className="px-4 py-2.5 font-medium text-foreground-800">Product Comparison</td>
                    <td className="px-4 py-2.5 text-foreground-500">Difficult</td>
                    <td className="px-4 py-2.5 text-accent-600 font-medium">Easy</td>
                  </tr>
                  <tr className="border-t border-background-200/50 bg-background-50">
                    <td className="px-4 py-2.5 font-medium text-foreground-800">Beginner Friendly</td>
                    <td className="px-4 py-2.5 text-foreground-500">No</td>
                    <td className="px-4 py-2.5 text-accent-600 font-medium">Yes</td>
                  </tr>
                  <tr className="border-t border-background-200/50">
                    <td className="px-4 py-2.5 font-medium text-foreground-800">Time Saving</td>
                    <td className="px-4 py-2.5 text-foreground-500">Low</td>
                    <td className="px-4 py-2.5 text-accent-600 font-medium">High</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a
              href="/article/what-is-sugargoo-spreadsheet"
              className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read the full guide
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}